import { 
    REFERRAL_ORDER_TYPE_GET_REQUEST, REFERRAL_ORDER_TYPE_GET_SUCCESS, REFERRAL_ORDER_TYPE_GET_ERROR, 
    REFERRAL_ORDER_TYPE_GET_BY_KEY_REQUEST, REFERRAL_ORDER_TYPE_GET_BY_KEY_SUCCESS, REFERRAL_ORDER_TYPE_GET_BY_KEY_ERROR, 
    REFERRAL_ORDER_TYPE_ADD_REQUEST, REFERRAL_ORDER_TYPE_ADD_SUCCESS, REFERRAL_ORDER_TYPE_ADD_ERROR, 
    REFERRAL_ORDER_TYPE_EDIT_REQUEST, REFERRAL_ORDER_TYPE_EDIT_SUCCESS, REFERRAL_ORDER_TYPE_EDIT_ERROR, 
    REFERRAL_ORDER_TYPE_DELETE_REQUEST, REFERRAL_ORDER_TYPE_DELETE_SUCCESS, REFERRAL_ORDER_TYPE_DELETE_ERROR
} from "../constants/referralOrderTypeConstants";

const initialState = {
    referralOrderTypes: [],
    referralOrderType: {},
    loading: false,
    success: null,
    error: null,
    referralOrderTypeRequestedCount: 0,
};

export const referralOrderTypeReducer = (state = initialState, action) => {
    switch (action.type)     {
        case REFERRAL_ORDER_TYPE_GET_REQUEST:
            return {
                ...state,
                referralOrderTypeRequestedCount: ++state.referralOrderTypeRequestedCount,
                loading: true,
            };
        case REFERRAL_ORDER_TYPE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                referralOrderTypes: action.payload,
                success: true,
            };
        case REFERRAL_ORDER_TYPE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ORDER_TYPE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ORDER_TYPE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                referralOrderType: action.payload,
                success: true,
            };
        case REFERRAL_ORDER_TYPE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ORDER_TYPE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ORDER_TYPE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_ORDER_TYPE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ORDER_TYPE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ORDER_TYPE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_ORDER_TYPE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ORDER_TYPE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ORDER_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_ORDER_TYPE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
